import { IDescriptionHolding } from '@core/models/interfaces/holding/description-holding.interface';
import { IHolding } from '@core/models/interfaces/holding/holding.interface';
import { HoldingItem } from './holding-item.model';

export class Holding {
  holding!: HoldingItem;
  companies!: HoldingItem[];

  constructor(value: IHolding) {
    this.holding = new HoldingItem(value.holding);
    this.companies = value.companies.map(
      (company: IDescriptionHolding) => new HoldingItem(company)
    );
  }
}
